class Event {
    #events = {};

    /**
     * @description 调用事件方法
     */
    emit(eventName, a, b, c, d, e, f, g) {
        let _self = this;
        if (_self.#events[eventName]) {
            _self.#events[eventName].forEach(function (cb) {
                cb(a, b, c, d, e, f, g);
            });
        }
    }

    /**
     * @description 绑定事件
     * @param {String} eventName 事件名
     * @param {Function} callback 回调方法
     */
    on(eventName, callback) {
        let _self = this;
        if (_self.#events[eventName]) {
            //不是第一次
            let flag = false;
            _self.#events[eventName].forEach((cb) => {
                if (cb == callback) flag = true;
            });
            if (!flag) {
                //防止重复绑定
                _self.#events[eventName].push(callback);
            }
        } else {
            _self.#events[eventName] = [callback];
        }
    }

    /**
     * @description 移除事件
     * @param {String} eventName 事件名
     */
    off(eventName) {
        let _self = this;
        if (_self.#events[eventName]) {
            //不是第一次
            delete _self.#events[eventName];
        }
    }
}

export default Event;